import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { Column } from '../../interfaces/column.interface';
import { ListDataService, ListColumnsService, ApplicationsDataService } from '../../services';
import { List, ListResult } from '../../interfaces';
import { FileUpload } from 'primeng/fileupload';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService],
})
export class ListComponent implements OnInit, OnDestroy {
  public dateForm: FormGroup = new FormGroup({});
  halfMonths = [
    { label: 'Première moitié (1 - 15)', value: 1 },
    { label: 'Deuxième moitié (16 - fin)', value: 2 }
  ];
  public articlesToDelete: List = {};
  public list: List[] = [];
  public allList: List[] = [];

  public data: any = {};
  public selectedArticles: List[] = [];
  public submitted: boolean = false;
  public parameters: { [param: string]: string | string | string | string[] } = { applicationId:'', month: '05', year: '2024'};
  public chunkSize: number = 200;
  public columns: Column[] = [];
  public isLoading: boolean = false;
  public isInitialized: boolean = false;
  public locale: string = (localStorage.language) ? localStorage.language : 'en';
  private _selectedColumns: Column[] = [];
  @ViewChild('importer', { static: false })
  public importer?: FileUpload;
  public importChooseLabel: string = 'Import';
  public importLabel: string = 'Import CSV';
  public month:any;
  public year:any;
  public applications: []=[];
  public selectedApplication: any = null; // Application sélectionnée
  public filteredList:any = []; // Liste filtrée
  public allApplications: []=[];
  public halfMonth: any = null; // Application sélectionnée

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private listDataService: ListDataService,
    private listColumnsService: ListColumnsService,
    public applicationsDataService: ApplicationsDataService
  ) {
    this.importChooseLabel = this.translate.instant('TOOLS.IMPORT');
    this.importLabel = this.translate.instant('TOOLS.IMPORTCSV');
  }

  ngOnInit(): void {
    this.isInitialized = true;
    this.titleService.setTitle('List - Management');
    this.primengConfig.ripple = true;
    this.prepareFrom();
    this.getApplications();
  
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth !== null) {
      const data = JSON.parse(jsonAuth);
      this.selectedApplication = data.application[0].id;
      
    // Si application différente de 7 et 2 → appel normal
    if (this.selectedApplication !== 7 && this.selectedApplication !== '2') {
      this.parameters.applicationId = this.selectedApplication;
      this.getList();
    }

    // Si application = 2 → appel spécifique avec halfMonth
    else if (this.selectedApplication === 2 || this.selectedApplication === '2') {
      this.parameters.applicationId = this.selectedApplication;
      console.log("Application 2 détectée - chargement avec halfMonth...");
      this.getListTop50withHalfMonth();
    }



    } else {
      console.error("Aucune information d'application trouvée dans le localStorage.");
    }
  }
  prepareFrom(): void {
    this.dateForm = new FormGroup({
      month: new FormControl(this.data.month, []),
      halfMonth: new FormControl(this.data.halfMonth, [])
    });
    console.log(this.dateForm, this.dateForm)
  }

 padTo2Digits(num:any) {
  return num.toString().padStart(2, '0');
}

getApplications(): void {
  this.isLoading = true;
  if (!this.isInitialized) {
    return;
  }
  this.applicationsDataService.getApplications().subscribe((response) => {
    this.isLoading = false;
    if (response !== null) {
      this.setColumns();
      this.applications = response.success.data;
    }
  }, (error: any) => {;
    this.isLoading = false;
    this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ApplicationSNOTLOADED')});
  });
}
  submitFormByMonth(redirect: boolean) {

    console.log(this.dateForm.value, 'test maroua');

    var date = new Date(this.dateForm.value.month);
    this.year = date.getFullYear();
    this.month = this.padTo2Digits(date.getMonth() + 1);
    this.halfMonth = this.dateForm.value.halfMonth;
    console.log('halfMonth', this.halfMonth)
    // this.getList();
    this.getList();
    if (!this.dateForm.valid) {
      this.showErrors();
    }
  }

  submitForm(redirect: boolean) {

    console.log(this.dateForm.value, 'test maroua');

    var date = new Date(this.dateForm.value.month);
    this.year = date.getFullYear();
    this.month = this.padTo2Digits(date.getMonth() + 1);
    this.halfMonth = this.dateForm.value.halfMonth;
    console.log('halfMonth', this.halfMonth)
    this.getListTop50withHalfMonth();
    if (!this.dateForm.valid) {
      this.showErrors();
    }
  }

  showErrors() {
    this.showErrors();
    const invalidFields: string[] = [];
    Object.keys(this.dateForm.controls).forEach((field: any) => {
      const control = this.dateForm.get(field);
      if (control !== null) {
        control.markAsTouched({ onlySelf: true });
        if (control.invalid) {
          invalidFields.push(field);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.isInitialized = false;
  }
 


  getList(): void {
    this.list = [];
  
    if (!this.isInitialized) return;
  
    if (!this.parameters.applicationId) {
      console.warn('Aucune application sélectionnée. Annulation du chargement.');
      return;
    }
  
    this.parameters.month = this.month;
    this.parameters.year = this.year;

    const requestData = {
      applicationId: this.parameters.applicationId

    };
  
    console.log('this.parameters', this.parameters);
  
    if (parseInt(this.parameters.month + '', 10) === 0) {
      this.isLoading = true;
    }
  
    this.listDataService.getListTop50(this.parameters, requestData).subscribe(
      (response: ListResult | any) => {
        this.isLoading = false;
  
        if (!response || !response.success || !response.success.data) {
          console.warn("Réponse vide ou invalide");
          return;
        }
  
        let resultList = response.success.data;
        console.log('Liste reçue:', resultList);
  
        if (parseInt(this.parameters.month + '', 10) === 0) {
          this.list = resultList;
        } else {
          this.list = this.list.concat(resultList);
        }
  
        this.setColumns();
  
        if (response.inlineCount > this.list.length) {
          this.parameters.month = (parseInt(this.parameters.month + '', 10) + 1).toString();
          this.getList();
        } else {
          this.parameters.month = '0';
        }
      },
      (error: any) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('UI.ERROR'),
          detail: this.translate.instant('UI.ARTICLESNOTLOADED')
        });
      }
    );
  }
  
  getListTop50withHalfMonth(): void {
    this.isLoading = true; // début du chargement
    this.parameters.month = this.month;
    this.parameters.year = this.year;
    this.parameters.halfMonth = this.halfMonth;
  
    const requestData = {
      applicationId: this.parameters.applicationId,
      halfMonth: this.parameters.halfMonth
    };
  
    this.listDataService.getListTop50withHalfMonth(this.parameters, requestData).subscribe(
      (response: ListResult | any) => {
        this.isLoading = false;
  
        if (!response || !response.success || !response.success.data) {
          this.list = []; // aucun résultat
          return;
        }
  
        this.list = response.success.data;
        this.setColumns();
      },
      (error: any) => {
        this.isLoading = false;
        this.list = []; // en cas d'erreur aussi
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('UI.ERROR'),
          detail: this.translate.instant('UI.ARTICLESNOTLOADED')
        });
      }
    );
  }
  

  setColumns() {
    if (this.columns.length > 0) {
      return;
    }
    this.columns = this.listColumnsService.getColumns();
    for (let i = 0; i < this.columns.length; i++) {
      if (this.columns[i].show) {
        this._selectedColumns.push(this.columns[i]);
      }
    }
  }

  @Input()
  get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    // restore original order
    this._selectedColumns = this.columns.filter((col: any) => val.includes(col));
    this.updateColumns();
  }

  updateColumns() {
    for (let i = 0; i < this.columns.length; i++) {
      const show = this._selectedColumns.includes(this.columns[i]);
      this.columns[i].show = show;
      this.navigation.setParamValue('posts.' + this.columns[i].field + '.showFiled', show);
    }
  }

  exportPdf() {
    ToolsService.exportPdf(this.list, this.columns, 'Liste Top 50');
  }

  exportExcel() {
    ToolsService.exportExcel(this.list, this.columns, 'Liste Top 50');
  }

  exportCsv() {
    ToolsService.exportCsv(this.list, this.columns, 'Liste Top 50');
  }

  refresh() {
    this.getList();
  }
  filterByApplication() {
    if (this.selectedApplication && this.selectedApplication.id) {
      this.parameters.applicationId = this.selectedApplication.id;
      this.getList(); // Rafraîchir la liste avec la nouvelle application sélectionnée
    }
  }
}
